const state = {
  isLoadingProjects: true,
  projects: [],
};

const getters = {
  isLoadingProjects: (state) => state.isLoadingProjects,
  projects: (state) => state.projects,
};

const mutations = {
  UPDATE_LOADING_PROJECTS(state, isLoadingProjects) {
    state.isLoadingProjects = isLoadingProjects;
  },
  UPDATE_PROJECTS(state, projects) {
    state.projects = projects;
  },
};

const actions = {
  updateIsLoadingProjects({ commit }, payload) {
    commit("UPDATE_LOADING_PROJECTS", payload);
  },
  updateProjects({ commit }, payload) {
    commit("UPDATE_PROJECTS", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
